import { Call, Mail } from '@epilot360/icons'
import styled from 'styled-components'

import { TEXT_TYPE } from './translations/Text'
import Translator from './translations/Translator'

const ContactSupport = () => {
  return (
    <Container>
      <Contact>
        <Mail variant="filled" />
        <Value>
          <Translator
            style={{ minWidth: '155px' }}
            translationKey="my_orders.help_email"
            type={TEXT_TYPE.BODY}
          />
        </Value>
      </Contact>

      <Contact>
        <Call variant="filled" />
        <Value>
          <Translator
            translationKey="my_orders.help_phone"
            type={TEXT_TYPE.BODY}
          />
        </Value>
      </Contact>
    </Container>
  )
}

export default ContactSupport

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px 24px;

  & > span:first-child {
    margin-bottom: 10px;
  }
`

const Contact = styled.span`
  display: flex;
  align-items: center;
`

const Value = styled.div`
  margin-left: auto;
  flex: 1;
  display: flex;
  justify-content: flex-end;

  & > div {
    text-align: right;
    padding-right: 0;
    margin-right: 0;
  }

  p {
    font-weight: 700;
  }
`
